import React from 'react';
import './Reports.css';

export default function ReportHeader(props) {
  const { handleToggleReport, reportName } = props;

  return (
    <div className="reports-nav-wrapper">
      <button
        type="button"
        className={`reports-nav-btn ${reportName === 'JournalIssues' ? 'active' : ''}`}
        onClick={(event) => handleToggleReport(event, 'JournalIssues')}
      >
        <i className="bi bi-journal-text"></i>
        <span>Journal Issues Received</span>
        <span className="reports-nav-badge">New</span>
      </button>
      <button
        type="button"
        className={`reports-nav-btn ${reportName === 'Books' ? 'active' : ''}`}
        onClick={(event) => handleToggleReport(event, 'Books')}
      >
        <i className="bi bi-journals"></i>
        <span>Books Inventory</span>
      </button>

      <button
        type="button"
        className={`reports-nav-btn ${reportName === 'Issue' ? 'active' : ''}`}
        onClick={(event) => handleToggleReport(event, 'Issue')}
      >
        <i className="bi bi-arrow-repeat"></i>
        <span>Circulation & Loans</span>
      </button>



      {/*<button
        type="button"
        className={`reports-nav-btn ${reportName === 'Custom' ? 'active' : ''}`}
        onClick={(event) => handleToggleReport(event, 'Custom')}
      >
        <i className="bi bi-search"></i>
        <span>Catalogue Search</span>
      </button>*/}
    </div>
  );
}
